import { useEffect, useState } from 'react';
import { Badge, Box } from '@chakra-ui/react';
import { config } from 'variables/config';
import { useAuthHeader } from 'react-auth-kit';
import axios from 'axios';
import { BsArrowRightCircle, BsBank, BsFilePdf, BsPlusCircle, BsXCircleFill } from 'react-icons/bs';
import MButton from 'components/Mbutton';
import { formatNumber } from 'utils';
import MuiTable from 'components/MuiTable';
import { Alert, AlertTitle, ButtonGroup, Chip, Stack, Typography } from '@mui/material';
import MuiSelect from 'components/MuiSelect';
import MuiDatePicker from 'components/MuiDatePicker';
import { useLocation, useNavigate } from 'react-router-dom';
import ReportModalInfos from './ReportModalInfos';
import PaginateBox from 'components/PaginateBox';
import AddRepport from './AddRepport';
import { REPORT_DOC_HEADER } from 'Constaints'; // Importer comme une fonction
import PDFViewer from 'components/PDFViewer';
import { formatDate } from 'utils';
import useDataFetching from 'hooks/useDataFetching';
import { capitalyse } from 'utils';
import AddEnterprise from '../enterprises/AddEnterprise';
import MuiAsyncAutocomplete from 'components/MuiAsyncAutocomplete';
import { castToRequestParams } from 'utils';
import ImageGallery from '../enterprises/ImageGallery';
import { getImageUrlAPI } from 'utils';
import MuiCollapse from 'components/MuiCollapse';
import { ENTERPRISE_SPY_HEADER } from 'Constaints'; // Importer comme une fonction
import AddSpyEnterprise from './AddSpyEnterprise';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next'; // Importer useTranslation

const ReportsSimple = ({ compact }) => {
  const { t } = useTranslation('reports_doc'); // Utiliser le namespace 'reports'
  const authHeader = useAuthHeader();
  const location = useLocation();
  const navigate = useNavigate();

  // Traduire les en-têtes de tableau
  const translatedReportDocHeader = REPORT_DOC_HEADER(t);
  const translatedEnterpriseSpyHeader = ENTERPRISE_SPY_HEADER(t);

  const [reports, setreports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [enterpriseIds, setEnterpriseIds] = useState([]);
  const [params, setParams] = useState({
    regionId: null,
    departmentId: null,
    arrondisementId: null,
    zoneId: null,
    start: null,
    end: null,
    page: 0,
    limit: 50,
    creatorId: null,
    enterpriseIds: null,
  });

  useEffect(() => {
    if (enterpriseIds?.length > 0) {
      setParams({
        ...params,
        enterpriseIds: enterpriseIds?.map((e) => e?.value)?.join(','),
      });
    } else {
      setParams({
        ...params,
        enterpriseIds: [],
      });
    }
  }, [enterpriseIds]);

  const [selectedReport, setSetselectedReport] = useState('');
  const [selectedEnterprise, setSelectedEnterprise] = useState(null);
  const [selectedEnterpriseQuery, setSelectedEnterpriseQuery] = useState(null);

  const [loadingR, errorR, regions, fetchDataR] = useDataFetching(`${config.app.api_url}/regions`);
  const [loadingEnter, errorEnter, enterprises, getEnterprise] = useDataFetching(
    selectedReport?.id ? `${config.app.api_url}/reports/${selectedReport?.id}/enterprises` : null
  );
  const [loadingD, errorD, departements, fetchDataD] = useDataFetching(
    params?.regionId
      ? `${config.app.api_url}/regions/${params?.regionId !== '*' && params?.regionId}/departments`
      : null
  );
  const [loadingA, errorA, arrondisements, fetchDataA] = useDataFetching(
    params?.departmentId
      ? `${config.app.api_url}/departments/${params?.departmentId}/arrondissements`
      : null
  );
  const [loadingZ, errorZ, zones, fetchZones] = useDataFetching(
    params?.regionId && params?.regionId !== '*'
      ? `${config.app.api_url}/regions/${params?.regionId}/zones`
      : `${config.app.api_url}/zones`
  );
  const [loadingEn, errorEn, enterprisesByReport, getEnterpriseByReport] = useDataFetching(
    !selectedReport?.id
      ? null
      : `${config.app.api_url}/reports/doc/${selectedReport?.id}/enterprises`
  );

  useEffect(() => {
    if (location.state) {
      setParams({
        regionId: location.state?.region?.id || null,
        departmentId: location.state?.departement || null,
        arrondisementId: location.state?.arrondisement || null,
        start: location.state?.start || null,
        end: location.state?.end || null,
        page: 0,
        limit: 50,
        creatorId: location?.state?.creator?.id || null,
      });
    }
  }, [location]);

  const [generatedFilename, setGeneratedFilename] = useState(
    formatDate(new Date()) + '_report.pdf'
  );
  const [loadingGen, setLoadingGen] = useState(false);

  const handleGenerateSelectedReport = () => {
    if (!selectedReport) {
      alert(t('select_report_prompt')); // Traduit
      return;
    }
    setLoadingGen(true);
    axios
      .post(
        `${config.app.api_url}/reports/doc/${selectedReport.id}/export-spy-report`,
        {},
        {
          headers: {
            Authorization: authHeader(),
          },
          responseType: 'blob',
        }
      )
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `rapport_${generatedFilename}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        toast.success(t('report_generated_success')); // Traduit
      })
      .catch((err) => {
        console.error('PDF download error:', err);
        toast.error(t('report_generated_error')); // Traduit
      })
      .finally(() => {
        setLoadingGen(false);
      });
  };

  const getReports = () => {
    setLoading(true);
    axios
      .get(`${config.app.api_url}/reports/doc?${castToRequestParams(params)}`, {
        headers: {
          Authorization: authHeader(),
        },
      })
      .then((res) => {
        setreports(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
        setreports([]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getReports();
  }, [params]);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    reports?.content?.length > 0 && setSetselectedReport(reports?.content[0]);
  }, [reports]);

  const handleClick = (item) => {
    if (item) {
      setSetselectedReport(item);
    }
  };

  // Les `rows` ne nécessitent pas de traduction ici car les labels sont dans `REPORT_DOC_HEADER`
  const rows = reports?.content?.map((item, index) => {
    return {
      selected: item?.id === selectedReport?.id,
      handleClick: () => handleClick(item),
      datas: {
        N: params?.page * params?.limit + (index + 1),
        Region: item?.region?.name,
        Date: formatDate(item?.date),
        Title: item?.title,
      },
    };
  });

  const enterpriseRows = enterprisesByReport?.data?.map((item) => {
    return {
      datas: {
        Name: item?.socialRaison,
        Ref: item?.reference,
        NBE: item?.employeesNumber,
        RE: item?.region?.name,
        DE: item?.department?.name,
        AR: item?.arrondissement?.name,
        GPS:
          item?.latitude && item?.longitude ? (
            <a
              style={{ color: 'skyblue', textDecoration: 'underline' }}
              href={`https://www.google.com/maps/search/?api=1&query=$${item.latitude},${item.longitude}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('see_on_map')}
            </a>
          ) : (
            '--'
          ),
      },
    };
  });

  const [isAddOpen, setIsAddOpen] = useState(false);
  const DetailsItem = ({ label, value }) => {
    return (
      <Stack direction={'row'} spacing={1}>
        <Typography variant="body2" className="text-start">
          {capitalyse(label) + ':'}
        </Typography>
        <Typography variant="body2" fontWeight={'bold'} className="text-start">
          {value ? capitalyse(value) : '--'}
        </Typography>
      </Stack>
    );
  };

  const [openEnterprise, setOpenEnterprise] = useState(false);
  const handleCloseEnter = () => {
    setOpenEnterprise(false);
    setSelectedEnterprise(null);
  };

  const [openAddEnterModal, setOpenAddEnterModal] = useState(false);

  return (
    <div>
      {selectedReport && (
        <AddSpyEnterprise
          referenceReport={selectedReport}
          isOpen={openAddEnterModal}
          onClose={() => {
            setOpenAddEnterModal(false);
          }}
          get={() => {
            getEnterpriseByReport();
          }}
        />
      )}

      <ReportModalInfos
        get={getReports}
        open={open}
        setOpen={setOpen}
        selectedReport={selectedReport}
        handleClose={() => {
          setSetselectedReport(null);
          setOpen(false);
        }}
      />

      <AddRepport isOpen={isAddOpen} onClose={() => setIsAddOpen(false)} get={getReports} />
      <AddEnterprise
        get={getReports}
        open={openEnterprise}
        handleClose={handleCloseEnter}
        selectedEnterpriseP={selectedEnterprise}
      />

      <div className=" grid h-full grid-cols-1 gap-5">
        <div className={'w-full h-full p-0 rounded-0 bg-white'}>
          <Box
            bg={'rgba(255, 255, 255, 1)'}
            boxShadow="lg"
            p={2}
            rounded={'md'}
            border="1px"
            borderColor="gray.200"
            className=" flex flex-wrap gap-1  items-end justify-end"
          >
            <MuiDatePicker
              label={t('period_start')}
              value={params?.start}
              onChange={(newValue) => {
                setParams({
                  ...params,
                  start: new Date(newValue)?.getTime(),
                });
              }}
              wrapperClasses={'flex-1 filter-item anime slideLeft'}
            />
            <MuiDatePicker
              value={params?.end}
              label={t('period_end')}
              onChange={(newValue) => {
                setParams({
                  ...params,
                  end: new Date(newValue)?.getTime(),
                });
              }}
              wrapperClasses={'flex-1 filter-item anime slideLeft'}
            />
            <MuiSelect
              label={t('region')}
              options={regions?.data}
              emptyLabel={t('national')}
              value={params?.regionId}
              defaultFormat={true}
              onChange={(e) => {
                setParams({
                  ...params,
                  regionId: e.target.value,
                  departmentId: null,
                  arrondissementId: null,
                });
              }}
              wrapperClasses={'flex-1 filter-item anime slideLeft'}
            />

            <MuiSelect
              label={t('department')}
              options={departements?.data}
              emptyLabel={t('regional')}
              disabled={!departements?.data}
              value={params?.departmentId}
              defaultFormat={true}
              onChange={(e) => {
                setParams({
                  ...params,
                  departmentId: e.target.value,
                  arrondissementId: null,
                });
              }}
              wrapperClasses={'flex-1 filter-item anime slideDown'}
            />

            <MuiSelect
              disabled={!zones?.data}
              label={t('zone')}
              value={params.zoneId}
              options={zones?.data?.map((z) => {
                return {
                  value: z?.id,
                  label: `Zone ${z?.number} ${z?.description ? '--' + z?.description : ''}`,
                };
              })}
              onChange={(e) => {
                setParams({
                  ...params,
                  zoneId: e.target.value,
                });
              }}
              emptyLabel={t('none')}
            />

            <MuiSelect
              label={t('arrondissement')}
              emptyLabel={t('departmental')}
              disabled={!arrondisements?.data}
              options={arrondisements?.data}
              value={params?.arrondissementId}
              defaultFormat={true}
              onChange={(e) => {
                setParams({
                  ...params,
                  arrondissementId: e.target.value,
                });
              }}
              wrapperClasses={'flex-1 filter-item anime slideDown'}
            />

            <MuiAsyncAutocomplete
              label={t('enterprises')}
              value={enterpriseIds}
              format={{ value: 'id', label: 'socialRaison' }}
              fetch={'enterprises/search-all-by-term'}
              handleChange={(event, item) => {
                setEnterpriseIds(
                  enterpriseIds?.find((enter) => enter?.value === item?.value)
                    ? enterpriseIds
                    : [...enterpriseIds, item]
                );
              }}
              wrapperClasses={'flex-1 filter-item anime slideRight'}
            />

            {enterpriseIds?.length > 0 && (
              <Stack direction={'row-reverse'} wrap={'wrap'} spacing={2} className="w-full">
                {enterpriseIds?.map((e, i) => {
                  return (
                    <Chip
                      label={
                        <span className="flex items-center justify-between gap-2">
                          <span className="text-sm text-gray-500">{e?.label}</span>
                          <BsXCircleFill
                            onClick={() => {
                              setEnterpriseIds(
                                enterpriseIds.filter((item) => item?.value !== e?.value)
                              );
                            }}
                          />
                        </span>
                      }
                      key={i}
                      className="flex items-center justify-start gap-2 "
                    ></Chip>
                  );
                })}
              </Stack>
            )}
          </Box>

          <Stack direction={'row'} spacing={2} className="my-4">
            <Stack direction={'column'} spacing={2} className="my-4">
              <PaginateBox
                compactMode={true}
                total={reports?.totalElements}
                rowsPerPage={params?.limit}
                handleChangeRowsPerPage={(event) => {
                  setParams({
                    ...params,
                    limit: parseInt(event.target.value),
                    page: 0,
                  });
                }}
                page={params.page}
                count={reports?.totalPages - 1}
                handleChange={(event, value) => {
                  setParams({ ...params, page: value });
                }}
              />

              <MuiTable
                hidePagiation={true}
                columns={translatedReportDocHeader}
                loading={loading}
                limit={params?.limit}
                rows={rows}
                textEmpty={t('no_reports')}
              />
            </Stack>

            <Stack direction={'column'} className="w-full" style={{ height: '100%' }}>
              {!selectedReport ? (
                <Alert severity="info">
                  <AlertTitle>{t('select_report_prompt')}</AlertTitle> {/* Traduit */}
                  {t('select_report_details')} {/* Traduit */}
                </Alert>
              ) : (
                <>
                  <Stack
                    direction={'column'}
                    spacing={1}
                    className="bg-gray-100 p-2 rounded-md shadow-md "
                  >
                    <div className="grid grid-cols-3 gap-1 my-0 ">
                      <DetailsItem label={t('date')} value={formatDate(selectedReport?.date)} />{' '}
                      {/* Traduit */}
                      <DetailsItem
                        label={t('transport_mode')}
                        value={selectedReport?.transportationMode}
                      />{' '}
                      {/* Traduit */}
                      <DetailsItem label={t('report_status')} value={selectedReport?.status} />{' '}
                      {/* Traduit */}
                      <DetailsItem
                        label={t('see_itinerary')}
                        value={
                          selectedReport?.itinerary ? (
                            <a
                              style={{ color: 'skyblue', textDecoration: 'underline' }}
                              target="_blank"
                              href={selectedReport?.itinerary}
                              rel="noopener noreferrer"
                            >
                              Itinéraire
                            </a>
                          ) : (
                            ''
                          )
                        }
                      />{' '}
                      {/* Traduit */}
                      <DetailsItem
                        label={t('agents')}
                        value={selectedReport?.agents
                          ?.map((e) => e.firstName + ' ' + e.lastName)
                          ?.join(',')}
                      />{' '}
                      {/* Traduit */}
                      <DetailsItem
                        label={t('used_tools')}
                        value={selectedReport?.usedTools?.join(',')}
                      />{' '}
                      {/* Traduit */}
                      <DetailsItem
                        label={t('arrival_time')}
                        value={formatDate(selectedReport?.date)}
                      />{' '}
                      {/* Traduit */}
                      <DetailsItem
                        label={t('team_leader')}
                        value={
                          selectedReport?.teamLeader?.firstName +
                          ' ' +
                          selectedReport?.teamLeader?.lastName
                        }
                      />{' '}
                      {/* Traduit */}
                      <DetailsItem label={t('phone')} value={selectedReport?.phone} />{' '}
                      {/* Traduit */}
                      <DetailsItem
                        label={t('enterprise_number')}
                        value={formatNumber(selectedReport?.enterpriseNumber)}
                      />{' '}
                      {/* Traduit */}
                      <DetailsItem
                        label={t('employee_number')}
                        value={formatNumber(selectedReport?.employeeNumber)}
                      />{' '}
                      {/* Traduit */}
                      <DetailsItem
                        label={t('zone_subzone')}
                        value={`${selectedReport?.zone?.name || ''} / ${selectedReport?.subZone || ''}`}
                      />{' '}
                      {/* Traduit */}
                      <DetailsItem
                        label={t('creator')}
                        value={
                          selectedReport?.creator?.firstName +
                          ' ' +
                          selectedReport?.creator?.lastName
                        }
                      />{' '}
                      {/* Traduit */}
                    </div>
                  </Stack>
                  <div>
                    {enterprisesByReport?.data?.length > 0 && (
                      <MuiTable
                        hidePagiation={true}
                        columns={translatedEnterpriseSpyHeader}
                        withHistory={false}
                        rows={enterpriseRows}
                      />
                    )}
                  </div>

                  {selectedReport?.files?.filter(
                    (i) => i?.fileType?.toLowerCase() !== 'application/pdf'
                  ).length > 0 && (
                    <MuiCollapse
                      title={t('image_files_associated', {
                        count:
                          selectedReport?.files?.filter(
                            (i) => i?.fileType?.toLowerCase() !== 'application/pdf'
                          ).length || 0,
                      })}
                      bgColor={'rgba(0,150,0,0.1)'}
                    >
                      <ImageGallery
                        images={selectedReport?.files
                          ?.filter((i) => i?.fileType?.toLowerCase() !== 'application/pdf')
                          ?.map((img) => {
                            return {
                              original: getImageUrlAPI(img?.fileName),
                              thumbnail: getImageUrlAPI(img?.fileName),
                            };
                          })}
                      />
                    </MuiCollapse>
                  )}

                  {selectedReport?.files?.filter(
                    (i) => i?.fileType?.toLowerCase() === 'application/pdf'
                  ).length > 0 && (
                    <MuiCollapse
                      title={t('pdf_files_associated', {
                        count:
                          selectedReport?.files?.filter(
                            (i) => i?.fileType?.toLowerCase() === 'application/pdf'
                          ).length || 0,
                      })}
                      bgColor={'rgba(0,150,0,0.1)'}
                    >
                      {selectedReport?.files
                        ?.filter((i) => i?.fileType?.toLowerCase() === 'application/pdf')
                        ?.map((pdf, index) => (
                          <PDFViewer key={index} fileName={pdf?.fileName} />
                        ))}
                    </MuiCollapse>
                  )}
                </>
              )}
            </Stack>
          </Stack>
        </div>
      </div>
      <ButtonGroup
        className="absolute left-44 bottom-4 flex gap-2"
        variant="text"
        aria-label="Basic button group"
      >
        <MButton variant={'primary'} onClick={() => setIsAddOpen(true)}>
          <BsPlusCircle />
          {t('new_survey')} {/* Traduit */}
        </MButton>
      </ButtonGroup>

      <ButtonGroup
        className="absolute right-4 bottom-4 flex gap-2"
        variant="text"
        aria-label="Basic button group"
      >
        <MButton
          variant={'secondary'}
          onClick={handleGenerateSelectedReport}
          isLoading={loadingGen}
        >
          <BsFilePdf />
          {t('generate_this_report')} {/* Traduit */}
        </MButton>

        <MButton variant={'info'} onClick={() => setOpenAddEnterModal(true)}>
          <BsBank />
          {t('add_enterprise')} {/* Traduit */}
        </MButton>
      </ButtonGroup>
    </div>
  );
};

export default ReportsSimple;
